import http from '@axios'

export function getContracts(params) {
  return http({
    method: 'GET',
    url: 'clients/contract/',
    params,
  })
}

export function createContract(data) {
  return http({
    method: 'POST',
    url: 'clients/contract/',
    data,
  })
}

export function updateContract(data) {
  return http({
    method: 'PATCH',
    url: `/clients/contract/${data.id || data.get('id')}/`,
    data,
    timeout: 0,
  })
}

export function getOneContract(id) {
  return http({
    method: 'GET',
    url: `/clients/contract/${id}/`,
  })
}

export function updateOneContract({
  id,
  ...data
}) {
  return http({
    method: 'PATCH',
    url: `/clients/contract/${id}/`,
    data,
  })
}

export function downloadContractPdf(id) {
  return http({
    method: 'GET',
    url: `/clients/contract/${id}/docx/`,
    responseType: 'blob',
  })
}

export function getContractHistory(id) {
  return http({
    method: 'GET',
    url: `/clients/contract/${id}/history`,
  })
}

export function createContractTemplate(data) {
  return http({
    method: 'POST',
    url: '/knowledge_base/template-file/',
    data,
  })
}

export function updateContractTemplate(data) {
  return http({
    method: 'PATCH',
    url: `/knowledge_base/template-file/${data.get('id')}/`,
    data,
  })
}

export function getContractTemplates(params) {
  return http({
    method: 'GET',
    url: '/knowledge_base/template-file/',
    params,
  })
}

export function getContractTemplatesFile(params) {
  return http({
    method: 'GET',
    url: '/knowledge_base/template-file/',
    params,
  })
}

export function getOneContractTemplate(params) {
  return http({
    method: 'GET',
    url: `/clients/template/${params.id}/`,
    params,
  })
}

export function getOneContractTemplateFile(params) {
  return http({
    method: 'GET',
    url: `/knowledge_base/template-file/${params.id}/`,
    params,
  })
}

export function deleteContractTemplate(id) {
  return http({
    method: 'DELETE',
    url: `/knowledge_base/template-file/${id}/`,
  })
}

export function getContractTemplateFields() {
  return http({
    method: 'GET',
    url: '/clients/template-field/',
  })
}